import Timeline from '@core/components/Timeline';
import { Grid, makeStyles } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { FaArrowCircleDown, FaCheckCircle, FaEdit, FaTimesCircle } from 'react-icons/fa';

export const styles = makeStyles({
  icone: {
    backgroundColor: '#919191',
  },
});

const tipoCampo = {
  DATA_VENCIMENTO: 'a data de vencimento',
  VALOR: 'o valor',
  VALOR_PAGO: 'o valor pago',
  DATA_PAGAMENTO: 'a data de pagamento',
  DATA_LIQUIDACAO: 'a data de liquidação',
  FORMA_PAGAMENTO: 'a forma de pagamento',
};

const origemBaixaLabel = {
  CONTA_PAGAR: 'manualmente',
  CONCILIACAO: 'pela conciliação bancária',
  COMPRA: 'pela compra',
  COMPRA_SERVICO: 'pela compra de serviço',
  COMPRA_PRODUTO: 'pela compra',
  CONTRATO_PB: 'pelo Partner Bank',
  VENDA_PB: 'pelo Partner Bank',
};

const HistoricoContasPagarVisualizacao = ({ historico }) => {
  const classes = styles();

  const getSubtitulo = (registro) => {
    return moment(registro.dataHora).format('HH:mm [do dia] DD/MM/YYYY');
  };

  const getIcone = (registro) => {
    if (registro.nomeCampo === 'BAIXA') {
      return <FaCheckCircle size={20} />;
    }
    if (registro.nomeCampo === 'CANCELAMENTO_BAIXA') {
      return <FaTimesCircle size={20} />;
    }
    if (['VALOR_PAGO', 'DATA_PAGAMENTO', 'DATA_LIQUIDACAO', 'FORMA_PAGAMENTO'].includes(registro.nomeCampo)) {
      return <FaEdit size={20} />;
    }

    return <FaArrowCircleDown size={20} />;
  };

  const getDescricao = (registro) => {
    const usuario = registro.nomeUsuario || 'Usuário';
    const origemLabel = origemBaixaLabel[registro.origem] || 'manualmente';

    if (registro.nomeCampo === 'BAIXA') {
      return `${usuario} realizou a baixa ${origemLabel}${
        registro.valorAtual ? ` no valor de R$ ${registro.valorAtual}` : ''
      }.`;
    }

    if (registro.nomeCampo === 'CANCELAMENTO_BAIXA') {
      return `${usuario} cancelou a baixa${registro.origem === 'CONCILIACAO' ? ' originada pela conciliação bancária' : ''}${
        registro.valorAnterior ? ` no valor de R$ ${registro.valorAnterior}` : ''
      }.`;
    }

    if (tipoCampo[registro.nomeCampo] && registro.nomeCampo !== 'DATA_VENCIMENTO' && registro.nomeCampo !== 'VALOR') {
      return `${usuario} editou ${tipoCampo[registro.nomeCampo]} da baixa de "${registro.valorAnterior}" para "${
        registro.valorAtual
      }".`;
    }

    if (tipoCampo[registro.nomeCampo]) {
      return `${usuario} alterou ${tipoCampo[registro.nomeCampo]} de "${registro.valorAnterior}" para "${
        registro.valorAtual
      }" na edição da despesa.`;
    }

    return '';
  };

  return (
    <Grid container spacing={3}>
      <Timeline
        registros={historico}
        pageSize={3}
        getIcone={getIcone}
        getSubtitulo={getSubtitulo}
        getDescricao={getDescricao}
        iconeStyles={classes.icone}
      />
    </Grid>
  );
};

export default HistoricoContasPagarVisualizacao;
